import React, { FC, useState } from 'react';
import { Button, Space } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

interface ConfirmButtonProps extends ButtonProps {
  confirmMessage?: string;
}
const ConfirmButton: FC<ConfirmButtonProps> = (props) => {
  const [firstClick, setFirstClick] = useState(false);

  const finalClick = (e) => {
    if (props?.onClick) props.onClick(e);
    setFirstClick(false);
  };

  return (
    <div>
      {firstClick ? (
        <div>
          <Space align="center">
            <div>{props.confirmMessage}</div>
            <Button
              icon={<CheckCircleOutlined style={{ color: 'green' }} />}
              onClick={finalClick}
            />
            <Button
              icon={<CloseCircleOutlined style={{ color: 'red' }} />}
              onClick={() => setFirstClick(false)}
            />
          </Space>
        </div>
      ) : (
        <Button {...props} onClick={() => setFirstClick(true)} />
      )}
    </div>
  );
};

ConfirmButton.defaultProps = {
  confirmMessage: 'Confermi ?',
};
export default ConfirmButton;
